import SvgColor from "../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig = [
  {
    title: "dashboard",
    path: "/",
    icon: icon("ic_analytics"),
  },
  {
    title: "talentos",
    path: "/talents",
    icon: icon("ic_user"),
  },
  {
    title: "Empresas",
    path: "/companies",
    icon: icon("ic_user"),
  },
  {
    title: "Parceiros",
    path: "/partners",
    icon: icon("ic_user"),
  },
  {
    title: "Academy",
    path: "/conteudos",
    icon: icon("ic_user"),
  },
  // {
  //   title: 'empresas',
  //   path: '/companies',
  //   icon: icon('ic_cart'),
  // },
  {
    title: "Questões",
    path: "/questions",
    icon: icon("ic_quiz"),
  },
  // {
  //   title: "Financeiro",
  //   path: "/finance",
  //   icon: icon("ic_finance"),
  // },
  {
    title: "Planos",
    path: "/planos",
    icon: icon("ic_finance"),
  },
  {
    title: "Sidekiq",
    path: "/sidekiq",
    icon: icon("ic_analytics"),
  },
  // {
  //   title: 'blog',
  //   path: '/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
